import type { UseFormReturnType } from '@mantine/form';

export type LooseKeys<Values> = Extract<keyof Values, string> | (string & {});

export const setEditorFieldValue = <TFormType, TValue>(
    form: UseFormReturnType<TFormType>,
    fieldKey: LooseKeys<TFormType>,
    value: TValue
) => {
    const keyedForm = form as unknown as UseFormReturnType<Record<string, TValue>>;
    keyedForm.setFieldValue(fieldKey, value, { forceUpdate: false });
};
